module.exports = __webpack_public_path__ + "img/chart1.269506a2.png";